import { render, staticRenderFns } from "./percentageProcessFrom.vue?vue&type=template&id=f48491a0&scoped=true"
import script from "./percentageProcessFrom.vue?vue&type=script&lang=js"
export * from "./percentageProcessFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48491a0",
  null
  
)

export default component.exports